import { useCallback } from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type EmailSMSLoginFormType, useEmailValidation } from './useAuthFormHelper';

export const useEmailFieldValidation = ({ setError }: UseFormReturn<EmailSMSLoginFormType>) => {
	const checkEmailAvailability = useEmailValidation();

	return useCallback(
		async (params: { email: EmailSMSLoginFormType['id'] }) => {
			const { error, formattedValues } = await checkEmailAvailability(params, { checkForEmailTaken: false });

			if (error) {
				const { field, ...rest } = error;

				// TODO: OFT-1459 - We need to remove the below condition once we get rid of the old login flow.
				setError(field === 'email' ? 'id' : field, rest);

				return;
			}

			return formattedValues;
		},
		[setError, checkEmailAvailability]
	);
};
